import { Box, Button, ButtonGroup, Flex, Popover, PopoverBody, PopoverContent, PopoverFooter, PopoverTrigger, Radio, RadioGroup, Stack, Tab, TabList, TabPanel, TabPanels, Tabs, useDisclosure } from '@chakra-ui/react';
import configs from '@components/ui/Datepicker/datepicker.config';
import IconCalendar from 'assets/icons/icon-calendar.svg?react';
import { OnDateSelected, RangeCalendarPanel } from 'chakra-dayzed-datepicker';
import PeriodTime from 'components/ui/PeriodTime';
import { useState } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';

type AnalyticsDateRangeProps = UseControllerProps;

const PREDEFINED_DATE_RANGES = {
  last1day: 'Último dia',
  last7day: 'Últimos 7 dias',
  last14day: 'Últimos 14 dias',
  last30day: 'Últimos 30 dias',
  last60day: 'Últimos 60 dias'
} 

export default function AnalyticsDateRange({ name, control, rules }: AnalyticsDateRangeProps) {
    const {
      field: { onChange, ...field },
    } = useController({
      name,
      control,
      rules,
    });

  const { onOpen, onClose, isOpen } = useDisclosure();
  const [selectedDates, setSelectedDates] = useState<Date[]>([]);
  const [value, setValue] = useState<string|Date[]>(field.value);

  const handleOnDateSelected: OnDateSelected = (props) => {
    
    const { date } = props;
    const newDates = [...selectedDates];
    if (selectedDates.length) {
      if (selectedDates.length === 1) {
        const firstTime = selectedDates[0];
        if (firstTime < date) {
          newDates.push(date);
        } else {
          newDates.unshift(date);
        }
        setValue(newDates);
        setSelectedDates(newDates);
        return;
      }

      if (newDates.length === 2) {
        setSelectedDates([date]);
        return;
      }
    } else {
      newDates.push(date);
      setSelectedDates(newDates);
    }
  };

  const isAbsoluteMode = Array.isArray(value);
  
  return (
    <Popover 
      placement="bottom-start"
      isLazy
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      closeOnBlur={false}
      closeOnEsc={false}
    >
      <PopoverTrigger>
        <Button
          leftIcon={<IconCalendar />}
          fontWeight={400}
          color="#000"
          w="full"
          justifyContent="left"
        >
          { isAbsoluteMode ? <PeriodTime startsAt={value[0]} endsAt={value[1]} noBreakLine />  : PREDEFINED_DATE_RANGES[value] }
        </Button>
      </PopoverTrigger>
      <PopoverContent w="auto">
        <PopoverBody>
          <Tabs 
            isLazy 
            variant="view"
            defaultIndex={isAbsoluteMode ? 1 : 0}
          >
            <Box maxW="max-content">
              <TabList>
                <Tab>Pré-definido</Tab>
                <Tab>Calendário</Tab>
              </TabList>
            </Box>
            <TabPanels>
              <TabPanel>
                <RadioGroup 
                  px="15px"
                  pt="20px"
                  pb="10px"
                  value={value}
                  onChange={(value) => {
                    setSelectedDates([]);
                    setValue(value);
                  }}
                >
                  <Stack direction="column">
                  { Object.entries(PREDEFINED_DATE_RANGES).map(([value, label]) => (
                    <Radio key={value} value={value}>{label}</Radio>
                  ))}
                  </Stack>
                </RadioGroup>
              </TabPanel>
              <TabPanel>
                <Box
                  px="15px"
                  py="20px"
                >
                  <RangeCalendarPanel
                    selected={selectedDates}
                    dayzedHookProps={{
                      showOutsideDays: false,
                      onDateSelected: handleOnDateSelected,
                      selected: selectedDates,
                      monthsToDisplay: 1,
                    }}
                    configs={configs}
                  />
                </Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </PopoverBody>
        <PopoverFooter>
          <Flex>
            <ButtonGroup ml="auto">
              <Button 
                variant="ghost" 
                onClick={() => {
                  setValue(field.value);
                  if (!Array.isArray(field.value))
                    setSelectedDates([]);
                  onClose();
                }}
              >
                Cancelar
              </Button>
              <Button 
                variant="primary"
                bgColor="black"
                onClick={() => {
                  onChange(value);
                  onClose();
                }}
              >
                Aplicar
              </Button>
            </ButtonGroup>
          </Flex>
        </PopoverFooter>
      </PopoverContent>
    </Popover>
  )
}
